export enum MessageActionType {
  Quit = 'quit', // Quit the game (just like pressing on the home button)
  Cashier = 'cashier', // Launch the cashier link (just like pressing on the cashier button)
  History = 'history', // Launch the history link (just like pressing on the history button on the reality check popup)
  Continue = 'continue', // Hide the popup
  Link = 'link', // Open (send Ajax request to) a dedicated link
}

export enum MessageLinkType {
  Redirect = 'redirect', //- redirects the player to the actionUrl
  Ajax = 'ajax', //- an Ajax request is sent to actionUrl and immediately let the player continue with the flow
  AjaxResponse = 'ajaxResponse', //- an Ajax request is sent to actionUrl and wait until "successful json response" is received. Only then continue with the flow
  Notify = 'notify', //- JavaScript event should be sent to parent window as postMessage()
  Open = 'open', //- Open link in new tab
}

export interface MessageAction {
  action?: MessageActionType;
  linkType?: MessageLinkType;
  url?: string;
  label?: string;
}

export interface PopupStackItem {
  popupName: string;
  popupData?: Record<string, unknown>;
}

export interface CustomPopup {
  text?: string;
  title?: string;
  withPlaceholders: boolean;
  nonIntrusive: boolean;
  options?: MessageAction[];
}
